import React from "react"
import BreadCrumbBase from "@components/BreadCrumb/base"

const BreadCrumb = ({ items }) => {
  return (
    <div>
      <div>
        <BreadCrumbBase items={items} />
      </div>
    </div>
  )
}

BreadCrumb.defaultProps = {
  items: [
    { label: "Home", url: "/" },
    { label: "Solutions", url: "/" },
    { label: "Buying" },
  ],
}

export default BreadCrumb
